import { render, staticRenderFns } from "./Cables.vue?vue&type=template&id=be649704&scoped=true"
import script from "./Cables.vue?vue&type=script&lang=js"
export * from "./Cables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be649704",
  null
  
)

export default component.exports